
import React, { useEffect, useRef, useState } from "react";
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Grid,
  Box,
  Button,
} from "@mui/material";

import DragAndDropUploader from "./ImageUploader";
import ImageUploadSection from "./ImageUploader";
import FormBrand from "./FormBrand";
import Link from "@mui/material/Link";
import BrandTable from "./BrandTable";
import { craetebrandsonly, editbrandsonly, getapprovalhistoryofbrands, getbrandbannerdetailsbyid, getbrandetails, uploadimage } from "./api";
import { getToken } from "../../utils/utils";
import { useLocation } from "react-router-dom";
import Boximageuploader from "./Boximageuploader";
import { useNavigate, useParams } from "react-router-dom";
import { useAlert } from "../../pages/AlertContext/AlertContext";
interface BrandDetails {
  id: any; // Replace `any` with the actual type if known
  requestedOn: string;
  brandName: any;
  availableLocations: any;
  tenPackMRP: any;
  twentyPackMRP: any;
  brandImage: any;
  status: any;
}
interface KeyVisualItem {
  src: string;
  id: number;
}

  export default function EditAddBrand() {
    const { id } = useParams();
    console.log(id, "nnnnnnnnnnnnnnnnnn")
    const token = getToken();
    const { showAlert } = useAlert();
      const [brandName, setBrandName] = useState("");
     
      const [availableLocation, setAvailableLocation] = useState<string[]>([]);

      const [branddetails, setbranddetails] = useState<any[]>([]);
    
      const [branddetails22, setbranddetails22] = useState<any[]>([]);
      const [branddetails1, setbranddetails1] = useState<BrandDetails | null>(null);
   
     


      const [formData, setFormData] = useState({
        brandName: "",
        availableLocation: "",
        packDetails: {
          "10's Pack MRP Amount": "",
          "20's Pack MRP Amount": "",
        },
        imageData: null,
      });
    
      const location = useLocation();
    
      const [imagedataValue, setimageDataValue] = useState<null>();
    
      useEffect(() => {
        if (location.state?.imageData) {
          console.log(
            location.state?.imageData,
            "location.state?.imageDatalocation.state?.imageData"
          );
          setimageDataValue(location.state.imageData);
        }
      }, []);



      
      console.log(imagedataValue, "imagedataValueimagedataValue");
      const [uploadedImage, setuploadedImage] = useState();

      const [largeimagedata, setlargeimagedata] = useState('');
      const [imageDataValue1, setimageDataValue1] = useState('');
      const [brand_availbale_locations, setbrand_availbale_locations] = useState<string[]>([]);
      const [BrandName1, setBrandName1] = useState('');
  
      const [ten_pack_MRP_amount, setten_pack_MRP_amount] = useState('');
      const [twenty_pack_MRP_amount, settwenty_pack_MRP_amount] = useState('');
      
      const [packDetails, setPackDetails] = useState({
        "10's Pack MRP Amount": "",
        "20's Pack MRP Amount": "",
      });
      useEffect(() => {
        setPackDetails({
          "10's Pack MRP Amount": ten_pack_MRP_amount,
          "20's Pack MRP Amount": twenty_pack_MRP_amount,
        });
      }, [ten_pack_MRP_amount, twenty_pack_MRP_amount]); 
      const [topPanel23value, settopPanel23value] = useState<null>();
      const [keyvisual123value, settopkeyvisual123value] = useState<null>();
     
      const [allInOne, setAllInOne] = useState<{
        topPanel: string | null;
        keyVisual: KeyVisualItem[];
      }>({
        topPanel: null,
        keyVisual: [],
      });
      

      const [imageData, setImageData] = useState({
        topPanel: largeimagedata || null,
        keyVisual: imageDataValue1
          ? imageDataValue1
              .split(",")
              .map((src) => ({ src: src.trim(), id: Date.now() }))
          : [],
      });
    const [previews, setPreviews] = useState<Record<string, string | null>>({
       topPanel: largeimagedata || null,
     });
 
 
      useEffect(() => {
         if (largeimagedata) {
           setImageData((prev) => ({ ...prev, topPanel: largeimagedata }));
           setPreviews((prev) => ({ ...prev, topPanel: largeimagedata }));
         }
     
         if (imageDataValue1) {
           const keyVisualImages = imageDataValue1.split(",");
           const keyVisualArray = keyVisualImages.map((src) => ({
             src: src.trim(),
             id: Date.now(),
           }));
           setImageData((prev) => ({ ...prev, keyVisual: keyVisualArray }));
     
           const previewUpdates: Record<string, string | null> = {};
           keyVisualArray.forEach((image, index) => {
             previewUpdates[`keyVisual${index + 1}`] = image.src;
           });
     
           setPreviews((prev) => ({ ...prev, ...previewUpdates }));
         }
       }, [largeimagedata, imageDataValue1]);
 
 
 
       const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
        if (!e.target.files || e.target.files.length === 0) return;
      
        const file = e.target.files[0];
        const formData = new FormData();
        formData.append("answer", file);
      
        try {
          const response = await uploadimage(formData, token);
          const uploadedFileName = response.data.fileName;
          const fullImageUrl = `${process.env.REACT_APP_API_URL}/uploads/${uploadedFileName}`;
      
          setPreviews((prevPreviews) => ({
            ...prevPreviews,
            [key]: fullImageUrl,
          }));
        } catch (error) {
          console.error("Image upload failed:", error);
        }
      };
    
             const navigate = useNavigate();

         console.log(previews.keyVisual1, previews.keyVisual2, "imageData3333333333333")

      useEffect(() => {
        console.log("Received state in /add-brand:", location.state);
    
        if (location.state) {
          console.log("Full location state:", location.state); 
    
          if (location.state.selectedTimeasiigntaskkeyVisual23) {
            console.log("Setting topPanel23value:", location.state.selectedTimeasiigntaskkeyVisual23);
            settopkeyvisual123value(location.state.selectedTimeasiigntaskkeyVisual23);
          }
    
          if (location.state.selectedTimeasiigntaskkeyVisual23topPanel23) {
            console.log("Setting keyVisual123value:", location.state.selectedTimeasiigntaskkeyVisual23topPanel23);
            settopPanel23value(location.state.selectedTimeasiigntaskkeyVisual23topPanel23);
          }

    
            if (location.state?.selectedTimeAssignimageData) {
              console.log("Setting keyVisual and topPanel separately:", location.state.selectedTimeAssignimageData);
              const { topPanel, keyVisual } = location.state.selectedTimeAssignimageData;
              setAllInOne((prevState) => ({
                ...prevState,
                topPanel: topPanel || null,  
                keyVisual: keyVisual || [], 
              }));
            }
        } else {
          console.warn("No state received in location!");
        }
      }, [location.state]);

           


      useEffect(() => {
        const createBrand = async () => {
          const reqBody = {
           id:String(id)
          };
      
          try {
            const response = await getbrandbannerdetailsbyid(reqBody, token);
      
            const data = response.data.data;
    
        setlargeimagedata(
          data.large_brand_image ? `${process.env.REACT_APP_API_URL}/uploads/${data.large_brand_image}` : ""
        );
        
        setimageDataValue1(
          data.image_path 
            ? data.image_path.includes(",") 
              ? data.image_path
                  .split(",")
                  .map((img: string) => img.trim() ? `${process.env.REACT_APP_API_URL}/uploads/${img.trim()}` : "")
                  .join(",") 
              : `${process.env.REACT_APP_API_URL}/uploads/${data.image_path.trim()}`
            : ""
        );
        
        
         setbrand_availbale_locations(data.brand_availbale_locations)
         setBrandName1(data.brand_name)
         setten_pack_MRP_amount(data.ten_pack_MRP_amount)
         settwenty_pack_MRP_amount(data.twenty_pack_MRP_amount)
          } catch (error) {
            console.error("Error creating brand:", error);
          }
        };
      
        createBrand();
      }, [id, token]); 
      
      console.log(imageDataValue1, "imageDataValue1444")
     
        const [imagedataValuekeyimage, setimageDataValuekeyimage] = useState<string>("");
      
       useEffect(() => {
          console.log("Received state in /add-brand:", location.state);
        
          if (location.state?.topPanel) {
            setimageDataValue(location.state.topPanel);
          }
        
          if (location.state?.keyVisual) {
            setimageDataValuekeyimage(location.state.keyVisual);
          }
        }, [location.state]);
      
    console.log(largeimagedata, "largeimagedatalargeimagedata")
     const handleAddBrand = async () => {
     
         if (!token) {
           console.error("Token is missing!");
           return;
         }
     
     console.log("Type of imagedataValuekeyimage:", typeof imagedataValuekeyimage);
  
         const reqBody = {
          id:String(id),
           brand_name:BrandName1|| brandName,
           image_path : [previews.keyVisual1, previews.keyVisual2]
  .filter((img): img is string => Boolean(img)) 
  .map((img) => img.replace(`${process.env.REACT_APP_API_URL}/uploads/`, "")),
           
          large_brand_image : previews.topPanel
          ? previews.topPanel.replace(`${process.env.REACT_APP_API_URL}/uploads/`, "")
          : "",
           
           brand_availbale_locations: brand_availbale_locations||availableLocation,
           ten_pack_MRP_amount:packDetails["10's Pack MRP Amount"],
           twenty_pack_MRP_amount: packDetails["20's Pack MRP Amount"],
        
         };
     
         try {
           const response = await editbrandsonly(reqBody, token);
     
           console.log("Brand added successfully:", response);
     
           const data = response.data.data;
     
           if (data) {
             const date = new Date(data.createdAt);
             const formattedDate = new Intl.DateTimeFormat("en-GB", {
               day: "2-digit",
               month: "short",
               year: "numeric",
             }).format(date);
     
             const mappedTask = {
               id: data.id,
               requestedOn: formattedDate,
               brandName: data.brand_name,
               availableLocations: data.brand_availbale_locations,
               tenPackMRP: data.ten_pack_MRP_amount,
               twentyPackMRP: data.twenty_pack_MRP_amount,
               brandImage: data.image_path,
               status: data.status,
             };
     
             setbranddetails1(mappedTask);
             showAlert("Brand update successfully!", "suaccess");

       navigate(`/brands`);
        setTimeout(() => window.location.reload(), 100);
           }
     
           await fetchBrandDetails();
         } catch (error: any) {
  console.error("Error adding brand:", error);

  // Check if the error has a response and data
  const errorMessage =
    error?.response?.data?.error ||
    error?.response?.data?.message ||
    "An unexpected error occurred";

  showAlert(errorMessage, "error");
}
       };
     
       const fetchBrandDetails = async () => {
        try {
          const reqBody = {
            brand_banner_id: String(id),
          };
      
          const response = await getapprovalhistoryofbrands(reqBody, token);
          console.log("Approval History:", response.data?.data);
      
          const details = response.data?.data?.map((item: any) => ({
            id: item.id,
            requestedOn: item.requested_on,
            brandName: item.brand_name,
            availableLocations: item.Available_Locations,
            tenPackMRP: item.ten_pack_MRP_amount,
            twentyPackMRP: item.twenty_pack_MRP_amount,
            brandImage: item.Brand_images,
            status: item.status,
          }));
      
          setbranddetails(details || []);
        } catch (error) {
          console.error("Error fetching brand details:", error);
        }
      };
      
      useEffect(() => {
        fetchBrandDetails();
      }, [id, token]);
     
      // Custom Error for brands strts//
      const [isFormValid, setIsFormValid] = useState(false);
      useEffect(() => {
        const isBrandValid = brandName.trim() !== '';
        const isLocationValid = availableLocation.length > 0;
        const is10sValid = packDetails["10's Pack MRP Amount"].trim() !== '' && 
                           !isNaN(Number(packDetails["10's Pack MRP Amount"]));
        const is20sValid = packDetails["20's Pack MRP Amount"].trim() !== '' && 
                           !isNaN(Number(packDetails["20's Pack MRP Amount"]));
      
        setIsFormValid(isBrandValid && isLocationValid && is10sValid && is20sValid);
      }, [brandName, availableLocation, packDetails]);
      
      // Custom Error for brands ends//
console.log(packDetails, "packDetailspackDetailspackDetails")
console.log(twenty_pack_MRP_amount,"twenty_pack_MRP_amounttwenty_pack_MRP_amount")

console.log(imageDataValue1, "fffffeeeeeeeeeeewwwwwwwwwwww")
  return (
    <div>
      
      <Box sx={{ padding: "28px 32px 0" }}>
        <Box
          sx={{
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography sx={{ display: "flex", fontSize: "14px" }}>
            Brands /
            <Typography sx={{ color: "#8E020F", fontWeight: "600" }}>
              Edit Marlboro Fuse Beyond
            </Typography>
          </Typography>
          <Typography
            variant="h3"
            sx={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#000",
              margin: "20px 0 20px",
              width: "100%",
            }}
          >
            Edit Marlboro Fuse Beyond
          </Typography>
        </Box>
      </Box>

      <Box sx={{ display: "flex", width: "98%" }}>
        <Box sx={{ width: "60%", padding: "0 32px" }}>
          {/* <ImageUploadSection setuploadedImage={setuploadedImage} /> */}
          <Boximageuploader largeimagedata= {largeimagedata} imageDataValue1={imageDataValue1} edit={1} keyvisuallength={imageDataValue1.split(',').length}  mainimagedata={imageDataValue1}  setPreviews={setPreviews}  handleFileChange={handleFileChange}  previews={Object.fromEntries(
    Object.entries(previews).map(([key, value]) => [key, value ?? ""])
  )} />
        </Box>
        <Box sx={{ width: "40%" }}>
          <FormBrand
            brandName={BrandName1||brandName}
            setBrandName={setBrandName1 ||setBrandName}
            availableLocation={brand_availbale_locations || availableLocation}
            setAvailableLocation={setbrand_availbale_locations || setAvailableLocation}
            packDetails={packDetails}
            setPackDetails={setPackDetails}
            city={"yashavanth"}
            // brand_availbale_locations={brand_availbale_locations}
          />
        </Box>
      </Box>
      <Box sx={{ padding: "30px 32px" }}>
        <BrandTable branddetails1={branddetails} />
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "16px",
          background: "#fff",
          fontSize: "14px",
        }}
      >
        <Link href="/" underline="none" sx={{ color: "#C8172F" }}>
          {"← Back"}
        </Link>
        <Button
          onClick={handleAddBrand}
          variant="contained"
          color="primary"
       
          sx={{
            background: "#C8172F",
            color: "#fff",
            width: "200px",
            padding: "10px 0",
            textTransform: "capitalize",
            fontSize: "14px",
          }}
        >
          Submit
        </Button>
      </Box>
    </div>
  );
}



